


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
// import  * as Constants from '../Constants/Constants'

// const Activities = () => {
//   const [eventData, setEventData] = useState(null); // State to hold event data
//   const [loading, setLoading] = useState(true); // State to manage loading state
//   const [error, setError] = useState(null); // State to manage error

//   // Function to handle API call using Axios
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(`${Constants.BASE_URL}?apitype=104`); // Replace with your actual API endpoint
//         if (response.data.status && response.data.statusCode === 200) {
//           setEventData(response.data.mEvents[0]); // Assuming first event in the array
//         }
//       } catch (err) {
//         setError("Failed to fetch data");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, []);

//   // Function to handle meeting button click
//   const handleMeetingClick = () => {
//     if (eventData && eventData.link) {
//       window.open(eventData.link, "_blank");
//     }
//   };

//   // Render the component
//   if (loading) {
//     return <div className="text-center mt-5">Loading...</div>;
//   }

//   if (error) {
//     return <div className="text-center mt-5 text-danger">{error}</div>;
//   }

//   return (
//     <div className="container mt-5">
//       <div className="row justify-content-center">
//         <div className="col-md-8 col-sm-10 col-12">
//           <div className="card">
//             <div className="card-body">
//               <h5 className="card-title">{eventData?.title}</h5>
//               <p className="card-text">
//                 {eventData?.descr.split("\r\n").map((line, index) => (
//                   <span key={index}>
//                     {line}
//                     <br />
//                   </span>
//                 ))}
//               </p>
//               <button className="btn btn-primary" onClick={handleMeetingClick}>
//                 {/* Google SVG Icon */}
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   fill="currentColor"
//                   className="bi bi-google"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z" />
//                 </svg>
//                 <span style={{ marginLeft: "5px" }}>Meeting</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Activities;

import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is imported
import * as Constants from "../Constants/Constants";

const Activities = () => {
  const [eventData, setEventData] = useState([]); // Initialize as an array to hold multiple events
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(null); // State to manage error

  // Function to handle API call using Axios
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${Constants.BASE_URL}?apitype=104`); // Replace with your actual API endpoint
        if (response.data.status && response.data.statusCode === 200) {
          setEventData(response.data.mEvents); // Set the entire array of events
        }
      } catch (err) {
        setError("Failed to fetch data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Function to handle meeting button click
  const handleMeetingClick = (link) => {
    if (link) {
      window.open(link, "_blank");
    }
  };

  // Render the component
  if (loading) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (error) {
    return <div className="text-center mt-5 text-danger">{error}</div>;
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-sm-10 col-12">
          {eventData.length > 0 ? (
            eventData.map((event, index) => (
              <div key={index} className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">{event.title}</h5>
                  <p className="card-text">
                    {event.descr.split("\r\n").map((line, lineIndex) => (
                      <span key={lineIndex}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleMeetingClick(event.link)}
                  >
                    {/* Google SVG Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-google"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z" />
                    </svg>
                    <span style={{ marginLeft: "5px" }}>Meeting</span>
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">No events available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Activities;

